import script from "./AdminPageShell.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminPageShell.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__